import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneratePopupComponent } from './generate-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [GeneratePopupComponent],
   imports: [
     CommonModule,
     MaterialModule,
     CustomDropdownModule,
     MatIconModule,
     FormsModule,
    
     ReactiveFormsModule,
   ],
   exports: [
     GeneratePopupComponent,
 
     
 
   ]
})
export class GeneratePopupModule { }
